export const DEFAULT_AUTH_REDIRECT = '/dashboard';

export const getLocationPath = (location) => {
  if (!location) {
    return DEFAULT_AUTH_REDIRECT;
  }

  if (typeof location === 'string') {
    return location;
  }

  return `${location.pathname || DEFAULT_AUTH_REDIRECT}${location.search || ''}${location.hash || ''}`;
};

export const isSafeRedirectPath = (path) => (
  typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//')
  && !path.includes('://')
);

export const getLoginRedirectLocation = (location) => {
  const redirect = getLocationPath(location);

  return {
    pathname: '/login',
    search: `?redirect=${encodeURIComponent(redirect)}`,
    state: { from: location },
  };
};

export const getPostLoginRedirectPath = (location) => {
  const params = new URLSearchParams(location?.search || '');
  const queryRedirect = params.get('redirect');

  if (isSafeRedirectPath(queryRedirect)) {
    return queryRedirect;
  }

  const stateRedirect = getLocationPath(location?.state?.from);

  if (isSafeRedirectPath(stateRedirect)) {
    return stateRedirect;
  }

  return DEFAULT_AUTH_REDIRECT;
};
